import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import UnauthenticatedTabs from "@/views/UnauthenticatedTabs.vue";
import AuthenticatedTabs from "@/views/AuthenticatedTabs.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/views/UnknownView.vue')
  },
  {
    path: '/ro/:id',
    component: () => import('@/views/ReadOnlyView.vue')
  },
  {
    // Unified customer-facing shopping cart. A cart may optionally
    // reference a machine; either way it renders here, not in ReadOnlyView.
    path: '/cart/:token',
    name: 'cart',
    component: () => import('@/views/CartView.vue')
  },
  {
    path: '/qs/:id',
    component: () => import('@/views/QuoteSurveyView.vue')
  },
  {
    path: '/c/',
    component: UnauthenticatedTabs,
    meta: { title: 'Deliveries' },
    children: [
      {
        path: '',
        redirect: '/c/unknown'
      },
      {
        path: 'd/:id',
        component: () => import('@/views/DeliveryView.vue')
      },
      {
        path: 'di/:id',
        component: () => import('@/views/DeliveryItem.vue')
      },
      {
        path: 'dk/:id',
        component: () => import('@/views/DeliveryKit.vue')
      },
      {
        path: 'h/:id',
        component: () => import('@/views/HistoryView.vue')
      },
      {
        path: 'c/:id',
        component: () => import('@/views/CommentsView.vue')
      },
      {
        path: 'sv/:id',
        component: () => import('@/views/ServiceView.vue')
      },
      {
        path: 'unknown',
        component: () => import('@/views/UnknownView.vue')
      }
    ]
  },
  {
    path: '/a/',
    component: AuthenticatedTabs,
    children: [
      {
        path: '',
        redirect: '/c/unknown'
      },
      {
          path: 'sv/conversation/:id',
          name: 'sv/conversation',
          component: () => import('@/views/ServiceConversationView.vue')
      },
      {
        path: 'sv/new/conversation/:id',
        name: 'sv/new/conversation',
        component: () => import('@/views/CreateServiceConversationView.vue')
      },
      {
        path: 'cu/:id',
        name: 'cu',
        component: () => import('@/views/CustomerUploadView.vue')
      },
      {
        path: 'ai/',
        name: 'ai',
        component: () => import('@/views/AILabView.vue')
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Per-feature browser tab title; index.html's <title>AutoDocs</title> is the default.
router.afterEach((to) => {
  const title = to.matched.map((record) => record.meta.title).filter(Boolean).pop() as string | undefined;
  document.title = title || 'AutoDocs';
});

export default router
